import {CompactPicker} from "react-color";
import ConfirmBox from "../../../components/common/Confirm";
import Button from "../../../components/common/Button";
import Input from "../../../components/common/Input";
import Select from "../../../components/common/Select";
import {
  HiTrash,
  HiOutlinePencil,
  HiArrowDown,
  HiArrowUp,
} from "react-icons/hi2";
import React, { useMemo, useState } from "react";

const PeriodInput = ({ label, value, onChange, min = 0, max = 1 }) => {
  const pickableValues = useMemo(() => {
    let vals = [];

    max = parseInt(max);
    let count = parseInt(min);
    while (count <= max) {
      vals.push(count);
      count++;
    }
    return vals;
  }, [min, max]);

  return (
    <div>
      <Select
        label={label}
        dontSort
        options={pickableValues.map((item, key) => ({
          key: key,
          text: item,
          value: "" + item,
        }))}
        value={"" + value}
        onChange={(e) =>  onChange(parseInt(e.target.value))}
      />
    </div>
  );
};

const blankData = {
  title: "",
  colour: "",
  months: 0,
  weeks: 0,
  days: 0,
  hours: 0,
};

const RotaShift = ({ shiftPattens = [], onChange }) => {
  const [editIndex, setEditIndex] = useState(null);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [data, setData] = useState(blankData);

  const handleDelete = () => {
    onChange(shiftPattens.filter((a, i) => i !== deleteIndex));
    setDeleteIndex(null);
  };
  const handleEdit = (d, i) => {
    setEditIndex(i);
    setData(d);
  };
  const handleReorder = (current, currentIndex, direction) => {
    let newList;
    let insertIndex;

    if (direction === -1) {
      insertIndex = currentIndex - 1;
      while (insertIndex < 0) {
        insertIndex = shiftPattens.length - insertIndex;
      }
    }
    if (direction === 1) {
      insertIndex = currentIndex + 1;
      while (insertIndex >= shiftPattens.length) {
        insertIndex = insertIndex - shiftPattens.length;
      }
    }

    const otherShifts = [
      ...shiftPattens.slice(0, currentIndex),
      ...shiftPattens.slice(currentIndex + 1),
    ];

    if (insertIndex === 0) {
      newList = [current, ...otherShifts];
    } else if (insertIndex === shiftPattens.length - 1) {
      newList = [...otherShifts, current];
    } else {
      newList = [
        ...otherShifts.slice(0, insertIndex),
        current,
        ...otherShifts.slice(insertIndex),
      ];
    }

    onChange(newList);
  };
  const handleFieldSave = () => {
    if (editIndex !== null) {
      onChange(
        shiftPattens.map((item, index) => {
          if (index !== editIndex) return item;
          return {
            ...item,
            ...data,
          };
        })
      );
    } else {
      onChange(shiftPattens.concat([data]));
      setData(blankData);
    }
  };

  return (
    <div>
      <ConfirmBox
        show={deleteIndex !== null}
        onClose={() => setDeleteIndex(null)}
        action={handleDelete}
        title={`Delete selected Shift Patten?`}
      />
      <div className="grid sm:grid-cols-3 w-full  items gap-2 align-middle p-4">
        <div className={"w-full"}>
          <div>
            <Input
              label={"Title"}
              field={"title"}
              value={data.title}
              onChange={e => setData({ ...data, title: e.target.value })}
            />
          </div>
        </div>
        <div className="text-center mx-auto items-center">
          <CompactPicker
            triangle="hide"
            colors={[
              "#FF6900",
              "#fff200",
              "#5dff00",
              "#8ED1FC",
              "#EB144C",
              "#9900EF",
            ]}
            color={data.colour}
            onChangeComplete={(e) => setData({ ...data, colour: e.hex })}
          />
        </div>
        <div className={"w-full grid sm:grid-cols-5 items-end gap-2"}>
          <PeriodInput
            label={"Months"}
            value={data.months}
            min={0}
            max={12}
            onChange={(a) => setData({ ...data, months: a })}
          />
          <PeriodInput
            label={"Weeks"}
            value={data.weeks}
            min={0}
            max={4}
            onChange={(a) => setData({ ...data, weeks: a })}
          />
          <PeriodInput
            label={"Days"}
            value={data.days}
            min={0}
            max={6}
            onChange={(a) => setData({ ...data, days: a })}
          />
          <PeriodInput
            label={"Hours"}
            value={data.hours}
            min={0}
            max={23}
            onChange={(a) => setData({ ...data, hours: a })}
          />
          <div>
            <Button onClick={handleFieldSave} variant="success" text={editIndex !== null ? "Update" : "Add"} />
          </div>
        </div>
      </div>
      <div className="w-full border-t">
        <table className="tableClass">
          <thead className="tableHeadClass">
            <tr className="tableHeadRowClass">
              <th className="tableHeadCellClass">Shift Name</th>
              <th className="tableHeadCellClass">Colour</th>
              <th className="tableHeadCellClass">Duration</th>
              <th className="tableHeadCellClass">Actions</th>
            </tr>
          </thead>
          <tbody className="tableBodyClass">
            {shiftPattens.map((d, i) => {
              return (
                <tr className={"tableBodyRowClass"} key={i}>
                  <td className="tableBodyCellClass">{d.title}</td>
                  <td className="tableBodyCellClass w-32" style={{ background: d.colour }}>
                    {d.colour}
                  </td>
                  <td className="tableBodyCellClass w-60">
                    {d.months ? d.months + "m " : ""}
                    {d.weeks ? d.weeks + "w " : ""}
                    {d.days ? d.days + "d " : ""}
                    {d.hours ? d.hours + "h" : ""}
                  </td>
                  <td className="tableBodyCellClass w-60">
                    <div className="flex justify-between ">
                      <div className="flex justify-start gap-1">
                        {i !== 0 && shiftPattens.length > 1 && (
                          <Button
                            variant="outline"
                            onClick={() => handleReorder(d, i, -1)}
                            text={(
                              <HiArrowUp className="h-6 w-6 text-gray-200" />
                            )}
                          />
                        )}
                        {i !== shiftPattens.length - 1 && (
                          <Button
                            variant="outline"
                            onClick={() => handleReorder(d, i, 1)}
                            text={(
                              <HiArrowDown className="h-6 w-6 text-gray-200" />
                            )}
                          />
                        )}
                      </div>
                      <div className="flex justify-end gap-1">
                        <Button
                          variant="outline"
                          onClick={() => handleEdit(d, i)}
                          text={(
                            <HiOutlinePencil className="h-6 w-6 text-gray-200" />
                          )}
                        />
                        <Button
                          onClick={() => setDeleteIndex(i)}
                          variant="destructive"
                          text={(
                            <HiTrash className="h-6 w-6 text-red-500" />
                          )}
                        />
                      </div>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};
export default RotaShift;
